// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { bindActionCreators } from 'redux';
import Map from '../components/Map';
import {
  getCampaigns,
  updateCurrentCampaign,
  updateCurrentCampaignStep
} from '../actions/campaigns/campaignCreators';
import type {
  Dispatch,
  Campaign,
  Organisation,
  Authentication
} from '../types';

const ENV = process.env.REACT_APP_ENV;

type Props = {
  currentCampaign: Campaign,
  currentOrganisation: Organisation,
  activeOrganisation: Organisation,
  authentication: Authentication,
  params: {
    campaignId: string,
    context: string,
    organisationId: string
  },
  route: {
    step: string
  },
  getCampaigns: Function,
  updateCurrentCampaign: Function,
  updateCurrentCampaignStep: Function,
  router: any
};

class MapContainer extends React.Component<Props> {
  componentDidMount() {
    window.addEventListener('message', this.handlePostMessage, false);
  }

  componentWillUnmount() {
    window.addEventListener('message', this.handlePostMessage, false);
  }

  handlePostMessage = async (event: MessageEvent) => {
    if (typeof event.data !== 'object') {
      return;
    }

    const { call, value } = event.data;

    switch (call) {
      case 'setCampaignStatus':
        return this.handleCampaignStatusMessage(value);
      case 'setCanExportStatus':
        return this.handleExportStatusMessage(value);
      case 'redirect':
        return this.handleRedirectMessage(value);
      case 'umDownloaded':
        return this.handleUmDownloadedMessage();
      default:
        return;
    }
  };

  handleCampaignStatusMessage = async (statusTypeId: number) => {
    this.props.updateCurrentCampaignStep(statusTypeId);
  };

  handleExportStatusMessage = async (value: boolean) => {
    localStorage.setItem('canExport', value);
  };

  handleRedirectMessage = async (page: string) => {
    let url =
      page === 'defaultPage'
        ? this.props.authentication.user.defaultPage || '/'
        : `/customer/${this.props.activeOrganisation.id}/campaigns/${this.props.currentCampaign.id}/${page}`;
    this.props.router.push(url);
  };

  handleUmDownloadedMessage = async () => {
    setTimeout(
      () =>
        this.props.updateCurrentCampaign(
          this.props.params.campaignId,
          this.props.params.organisationId
        ),
      2500
    );
  };

  getIframeUrl = (env, currentStep) => {
    const iframeDomain = this.getIframeDomain(env);
    const campaignId = this.props.params.campaignId;
    const organisationId = this.props.params.organisationId;
    const user = encodeURI(this.props.authentication.user.name);
    const token = this.props.authentication.token;
    const queryParams = `?campaignid=${campaignId}&organisationid=${organisationId}&user=${user}&token=${token}`;

    let iFrameUrl;
    switch (currentStep) {
      case 2:
        iFrameUrl = `${iframeDomain}/#/${queryParams}`;
        break;
      case 3:
        iFrameUrl = `${iframeDomain}/#/summary${queryParams}`;
        break;
      case 4:
        iFrameUrl = `${iframeDomain}/#/book${queryParams}`;
        break;
      default:
        iFrameUrl = undefined;
    }
    return iFrameUrl;
  };

  getIframeDomain = env => {
    /*
    return 'http://localhost:4200'; // Run locally
     */
    return env === 'prod'
      ? 'https://campaigntargetermaps.roymorgan.com'
      : 'https://campaigntargetermaps.roymorganuat.com';
  };

  render() {
    const currentStep = parseInt(this.props.route.step, 10);
    const iFrameUrl = this.getIframeUrl(ENV, currentStep);

    let title;
    switch (currentStep) {
      case 2:
        title = `Map Campaign | ${this.props.currentOrganisation.name ||
          ''} | Campaign Targeter`;
        break;
      case 3:
        title = `Review Campaign | ${this.props.currentOrganisation.name ||
          ''} | Campaign Targeter`;
        break;
      case 4:
        title = `Book Campaign | ${this.props.currentOrganisation.name ||
          ''} | Campaign Targeter`;
        break;
      default:
        title = `Manage Campaigns | ${this.props.currentOrganisation.name ||
          ''} | Campaign Targeter`;
    }

    return (
      <Grid fluid>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Row>
          <Col sm={12} className="map-maincontent">
            <Map
              {...this.props}
              currentStep={currentStep}
              iFrameUrl={iFrameUrl}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentOrganisation: state.currentOrganisation,
    activeOrganisation: state.activeOrganisation,
    currentCampaign: state.currentCampaign,
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getCampaigns,
      updateCurrentCampaign,
      updateCurrentCampaignStep
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);



// WEBPACK FOOTER //
// ./src/containers/MapContainer.js